import { MUIChip } from "@abb/arcadia-ui-react"
import { pki } from "node-forge"
import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import {
  AccessLevel,
  DimaFeatureShortNameEnum,
  hasUserAccessToApplicationFeature,
} from "../../../../models/Authorization"
import {
  LitePanelContainer,
  ManufacturedDeviceInfo,
} from "../../../../models/SupplierPortal"
import { UserInfo } from "../../../../models/User"

export function ManufacturedDeviceDetails(props: {
  readonly device: ManufacturedDeviceInfo
  readonly user: UserInfo
}) {
  const { device, user } = props

  const parsedContainers = JSON.parse(device.containers) as LitePanelContainer[]
  const containers = parsedContainers.map((item) => (
    <MUIChip
      size={24}
      id={item.Name}
      key={item.Name}
      label={`${item.Name}: ${item.Version}`}
    />
  ))

  const parsedAbility = JSON.parse(device.abbAbility)
  const certificate = pki.certificateFromPem(parsedAbility.AbbAbilityCertificate)

  const listItems = [
    {
      id: 0,
      label: "Serialnumber ABB",
      displayItem: <div>{device.serialNumberAbb}</div>,
    },
    {
      id: 1,
      label: "Serialnumber ASEM",
      displayItem: <div>{device.serialNumberAsem}</div>,
    },
    {
      id: 2,
      label: "Bootloader version",
      displayItem: <div>{device.bootloaderVersion}</div>,
    },
    {
      id: 3,
      label: "RecoveryOS version",
      displayItem: <div>{device.recoveryOsVersion}</div>,
    },
    { id: 4, label: "OS version", displayItem: <div>{device.osVersion}</div> },
    { id: 5, label: "Bios version", displayItem: <div>{device.biosVersion}</div> },
    { id: 6, label: "Bios date", displayItem: <div>{device.biosDate}</div> },
    {
      id: 7,
      label: "Firmware version",
      displayItem: <div>{device.firmwareVersion}</div>,
    },
    { id: 8, label: "WAN Mac", displayItem: <div>{device.wanMac}</div> },
    { id: 9, label: "LAN Mac", displayItem: <div>{device.lanMac}</div> },
    { id: 10, label: "Kernel version", displayItem: <div>{device.kernelVersion}</div> },
    { id: 11, label: "Board model", displayItem: <div>{device.boardModel}</div> },
    { id: 12, label: "Secure Boot", displayItem: <div>{device.secureBoot}</div> },
    {
      id: 13,
      label: "Device manager version",
      displayItem: <div>{device.deviceManagerVersion}</div>,
    },
    {
      id: 14,
      label: "Containers",
      displayItem: (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>{containers}</div>
      ),
    },
    { id: 15, label: "Product name", displayItem: <div>{device.productName}</div> },
    { id: 16, label: "ObjectId", displayItem: <div>{parsedAbility.ObjectID}</div> },
    { id: 17, label: "Otp", displayItem: <div>{parsedAbility.Otp}</div> },
    { id: 18, label: "PKI Url", displayItem: <div>{parsedAbility.PkiUrl}</div> },
    {
      id: 19,
      label: "Certificate valid from",
      displayItem: <div>{certificate.validity.notBefore.toDateString()}</div>,
    },
    {
      id: 20,
      label: "Certificate valid to",
      displayItem: <div>{certificate.validity.notAfter.toDateString()}</div>,
    },
    {
      id: 21,
      label: "Issuer",
      displayItem: (
        <div>
          {certificate.issuer.attributes.find((v) => v.name === "commonName")?.value}
        </div>
      ),
    },
  ]

  const detailsContentProps: DiMaDetailsContentProps<ManufacturedDeviceInfo> = {
    canWrite: hasUserAccessToApplicationFeature(
      user.authorizations.applications,
      device.id,
      DimaFeatureShortNameEnum.SP,
      AccessLevel.Write
    ),
    inlineEdit: false,
    listItems,
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
